<template>
    <v-btn id="btn-regenerate-ai-predictions"
           @click="onClick"
           v-tippy
           content="Re-generate"
           v-if="regenerateAIBasedPreviewsButton"
    >
        <v-icon size="18" class="fas fa-magic"></v-icon>
    </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("UI", ['regenerateAIBasedPreviewsButton']),
    },
    methods: {
        onClick() {
            window._Adjustments[lutify.getActiveBlock().name].regeneratePredictions();
        }
    }
}
</script>

<style lang="scss" scoped>
#btn-regenerate-ai-predictions {
    position: absolute;
    top: 27px;
    right: 15px;
    transform: translateY(-50%);

    min-width: auto;
    height: auto;
    box-shadow: none;
    background-color: transparent;
    color: var(--font-default-color);
    padding: 3px;
}
</style>